var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForwardSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ONE-xicons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,44.1a2.5,2.5,0,0,1-2.5-2.5V7.35a2.5,2.5,0,0,1,3.95-2L28.48,22.44a2.5,2.5,0,0,1,0,4.07l-0.29-.41,0.29,0.41L4.42,43.63A2.49,2.49,0,0,1,3,44.1ZM3,5.85A1.51,1.51,0,0,0,2.29,6a1.48,1.48,0,0,0-.81,1.33V41.6a1.5,1.5,0,0,0,2.37,1.22L27.9,25.7a1.5,1.5,0,0,0,0-2.44L3.84,6.13A1.49,1.49,0,0,0,3,5.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45,45.47H38a2.5,2.5,0,0,1-2.5-2.5V6A2.5,2.5,0,0,1,38,3.47h7A2.5,2.5,0,0,1,47.53,6V43A2.5,2.5,0,0,1,45,45.47Zm-7-41A1.5,1.5,0,0,0,36.53,6V43a1.5,1.5,0,0,0,1.5,1.5h7a1.5,1.5,0,0,0,1.5-1.5V6A1.5,1.5,0,0,0,45,4.47H38Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardSvgrepoCom);
export default __webpack_public_path__ + "static/media/forward-svgrepo-com.7b90fb92dffc21b9674ac87541551bc8.svg";
export { ForwardRef as ReactComponent };